module.exports = __webpack_public_path__ + "img/aab3.76880f22.jpg";